/* eslint eqeqeq: off */
import React from "react";
import './index.css';
import Modal, {ModalAction, ModalContent, ModalControls} from "../../../Components/Modal";
import Button from "../../../Components/Control/Button";
import Input from "../../../Components/Control/Input";
import Select from "../../../Components/Control/Select";
import {connect} from "react-redux";
import moment from "jalali-moment";
import Date from "../../../Components/Control/Date";
import Resource from "../../../Resource";
import PropTypes from 'prop-types';
import Check from "../../../Components/Control/Check";
import {Tool} from "../../../App";
import Notif from "../../../Components/Notif";
import MyComponent from '../../../Components/MyComponent';
import Org from "../../../Server/Org";

class ModalRequestProduct extends MyComponent {
    constructor(props) {
        super(props);
        props.refer.current = this;


        this.state = {
            title: {
                INSERT: 'افزودن فرآورده به درخواست',
                UPDATE: 'ویرایش فرآورده درخواست',
                VIEW: 'اطلاعات فرآورده درخواست'
            },
            bloodGroups: [
                {id: '', text: '...'},
                ...props.base.bloodGroups.map(item => {
                    return {id: item.id, text: item.name};
                })
            ],
            productTypes: [
                {id: '', text: '...'},
                ...props.base.productTypes.map(item => {
                    return {id: item.id, text: item.name, data: item};
                })
            ],
            fields: {},
            error: false,
            updated: false // this checks weather modal has been changed something or not
        };

        this.ref = {
            modal: React.createRef(),
            insert: React.createRef(),
            update: React.createRef(),
            close: React.createRef(),
            receiverUserId: React.createRef(),
            receiveDateTime: React.createRef(),
            bloodGroupId: React.createRef(),
            productTypeId: React.createRef(),
            productNumber: React.createRef(),
            expireDate: React.createRef(),
            collectionDate: React.createRef(),
            cellTypeTest: React.createRef()
        };
    }

    static defaultProps = {
        refer: {current: null},
        onClose: _ => null,
        onSuccess: _ => null
    };

    static propTypes = {
        refer: PropTypes.object,
        onClose: PropTypes.func,
        onSuccess: PropTypes.func
    };

    validations = {
        receiverUserId: x => Boolean(x && x[0]?.id) || 'نام کاربر تحویل گیرنده وارد نشده است.',
        receiveDateTime: x => Boolean(x) || 'تاریخ تحویل وارد نشده است.',
        bloodGroupId: x => Boolean(x && x[0]?.id) || 'گروه خونی انتخاب نشده',
        productTypeId: x => Boolean(x && x[0]?.id) || 'نوع فرآورده انتخاب نشده',
        productNumber: x => Boolean(x) || 'شماره فرآورده وارد نشده',
        expireDate: x => Boolean(x) || 'تاریخ انقضا فرآورده وارد نشده',
        collectionDate: x => Boolean(x) || 'تاریخ جمع آوری خون وارد نشده'
    };

    componentDidMount() {

    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const {state} = this;

        return state.action !== nextState.action ||
            state.error !== nextState.error ||
            state.fields !== nextState.fields;
    }

    render() {
        const {state, ref} = this;
        let readOnly = state.action === ModalAction.VIEW;

        return <Modal ref={ref.modal}
                      name={'ModalRequestProduct'}
                      size={'medium'}
                      title={state.title[state.action]}
                      error={state.error}
                      onClose={_ => {
                          if (this.state.updated)
                              this.props.onSuccess();
                      }}>
            <ModalContent>
                <div className={'dis-f'}>
                    <Select ref={ref.bloodGroupId} value={state.fields?.bloodGroupId} className={'pad-4 fb-10'} label={'گروه خونی'} readOnly={readOnly} options={state.bloodGroups} validation={this.validations.bloodGroupId} onChange={this.setField.bind(this, 'bloodGroupId')}/>
                    <Select ref={ref.productTypeId} value={state.fields?.productTypeId} className={'pad-4 fb-10'} label={'نوع فرآورده'} readOnly={readOnly} options={state.productTypes} validation={this.validations.productTypeId} onChange={this.setField.bind(this, 'productTypeId')}/>
                    <Input ref={ref.productNumber} value={state.fields?.productNumber} align={"center"} direction={'ltr'} className={'pad-4 fb-20'} readOnly={readOnly} label={'شماره فرآورده'} validation={this.validations.productNumber} onChange={this.setField.bind(this, 'productNumber')}/>
                    <Date ref={ref.expireDate} value={state.fields?.expireDate} className={'pad-4 fb-10'} label={'تاریخ انقضا'} readOnly={readOnly} min={moment().subtract(1, 'day')} validation={this.validations.expireDate} onEnter={this.insertClickHandler.bind(this)} onChange={this.setField.bind(this, 'expireDate')}/>
                    <Date ref={ref.collectionDate} value={state.fields?.collectionDate} className={'pad-4 fb-10'} label={'تاریخ جمع‌آوری'} readOnly={readOnly} max={moment()} validation={this.validations.collectionDate} onEnter={this.insertClickHandler.bind(this)} onChange={this.setField.bind(this, 'collectionDate')}/>
                    <Check ref={ref.cellTypeTest} disabled={(state.fields?.productTypeId || [])[0]?.data?.enzymeType != 1} checked={state.fields?.cellTypeTest} className={'pad-4'} label={'آزمایش سل تایپ برای فرآورده RBC انجام گردیده است.'} onChange={this.setField.bind(this, 'cellTypeTest')}/>
                </div>
            </ModalContent>
            <ModalControls>
                {state.action === ModalAction.INSERT && <Button refer={ref.insert} className={'mar-4'} theme={'blue'} onClick={this.insertClickHandler.bind(this)}>ثبت فرآورده</Button>}
                {state.action === ModalAction.UPDATE && <Button refer={ref.update} className={'mar-4'} theme={'yellow'} onClick={this.updateClickHandler.bind(this)}>ویرایش فرآورده</Button>}
                <Button refer={ref.close} className={'mar-4'} onClick={this.close.bind(this)}>بستن</Button>
            </ModalControls>
        </Modal>;
    }

    close(success) {
        this.ref.modal.current.close();

        if (success === true)
            this.props.onSuccess();

        this.props.onClose();
    }

    fieldWillUpdate(keys, value, currentFields, nextFields) {
        switch (keys[0]) {
            case 'productTypeId':
                if (value[0]?.data?.enzymeType != 1)
                    nextFields.cellTypeTest = false;
                break;
            default:
        }
    }

    insertClickHandler() {
        const {ref, state} = this;

        if (this.validate()) {
            ref.insert.current.loading();
            this.setState({error: null});

            Org.addProductToRequest({
                hospitalRequestId: state.data?.hospitalRequestId,
                bloodGroupId: state.fields?.bloodGroupId[0]?.id,
                productTypeId: state.fields?.productTypeId[0]?.id,
                productNumber: state.fields?.productNumber,
                expireDate: state.fields?.expireDate.format(),
                collectionDate: state.fields?.collectionDate ? state.fields?.collectionDate.format() : null,
                cellTypeTest: state.fields.productTypeId[0]?.data?.enzymeType == 1 ? state.fields?.cellTypeTest || false : null
            }).then(_ => {
                new Notif(Resource.STRING.FETCH.INSERT_SUCCESSFUL).show();
                ref.insert.current.loading(false);

                if (state.data?.scan) { // i'm in this modal to correct barcode scanner mismatch
                    this.close(true);
                } else { // i'm in this modal to insert handy
                    this.setField('productNumber', '');
                    ref.productNumber.current.focus();

                    this.setState({
                        updated: true
                    });
                }
            }).catch(message => {
                ref.insert.current.loading(false);

                this.setState({error: message});
            });
        }
    }

    open(data, action) {
        if (action === ModalAction.INSERT) {
            this.setState({
                data,
                action,
                fields: {...data},
                error: null,
                updated: false
            });
        } else if ([ModalAction.VIEW, ModalAction.UPDATE].includes(action)) {
            console.log(data);
            // getting enzymeType of productType
            const productTypeId = this.state.productTypes.find(item => item.id == data.productTypeId);
            this.setState({
                data,
                action,
                updated: false,
                fields: {
                    bloodGroupId: [{id: data.bloodGroupId}],
                    productTypeId: [productTypeId ? productTypeId : {id: data.productTypeId}],
                    productNumber: data.productNumber,
                    expireDate: moment(data.productExpireDate),
                    collectionDate: data.collectionDate ? moment(data.collectionDate) : null,
                    cellTypeTest: data.cellTypeTest || false
                },
                error: null
            });
        }

        return this.ref.modal.current.open()
            .then(_ => {
                if (data.bloodGroupId && action === ModalAction.INSERT)
                    this.ref.productNumber.current.focus();
            });
    }

    updateClickHandler() {
        const {state} = this;
        const {fields} = state;
        if (this.validate()) {
            this.ref.update.current.loading();
            this.setState({error: null});
            Org.editProductInRequest({
                orgProductId: state.data?.orgProductId,
                bloodGroupId: fields?.bloodGroupId[0]?.id,
                productTypeId: fields?.productTypeId[0]?.id,
                productNumber: fields?.productNumber,
                expireDate: fields?.expireDate.format(),
                collectionDate: fields?.collectionDate ? fields?.collectionDate.format() : null,
                cellTypeTest: fields.productTypeId[0]?.data?.enzymeType == 1 ? fields?.cellTypeTest || false : null
            }).then(_ => {
                new Notif(Resource.STRING.FETCH.UPDATE_SUCCESSFUL).show();
                this.ref.update.current.loading(false);
                this.close(true);
            }).catch(message => {
                this.ref.update.current.loading(false);
                this.setState({error: message});
            });
        }
    }

    validate() {
        const validate = Tool.validate(
            this.ref.receiverUserId,
            this.ref.receiveDateTime,
            this.ref.bloodGroupId,
            this.ref.productTypeId,
            this.ref.productNumber,
            this.ref.expireDate,
            this.ref.collectionDate);

        if (validate !== true)
            new Notif({message: validate.message, theme: 'error'}).show();

        return validate === true;
    }
}

const mapStateToProps = state => {
    return {
        base: state.base,
        hospitalId: state.user?.hospitalId
    };
};

export default connect(mapStateToProps)(ModalRequestProduct);